import { useState, useEffect } from "react";
import logo from '../assets/images/logo.png';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";



const HexPattern2 = () => (
  <svg
    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 1 }}
    viewBox="0 0 380 600"
    preserveAspectRatio="xMidYMid slice"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern id="hexgrid" x="0" y="0" width="52" height="60" patternUnits="userSpaceOnUse">
        <polygon points="26,2 50,15 50,45 26,58 2,45 2,15" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="1" />
      </pattern>
      <radialGradient id="netglow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
      </radialGradient>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2.5" result="blur" />
        <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
      <filter id="chipglow" x="-80%" y="-80%" width="260%" height="260%">
        <feGaussianBlur stdDeviation="4" result="blur" />
        <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>

    {/* hex grid texture */}
    <rect width="380" height="600" fill="url(#hexgrid)" />

    {/* subtle corner depth circles */}
    <circle cx="345" cy="65" r="110" fill="rgba(96,165,250,0.05)" />
    <circle cx="345" cy="65" r="60" fill="rgba(96,165,250,0.04)" />
    <circle cx="35" cy="535" r="90" fill="rgba(96,165,250,0.04)" />
    <circle cx="35" cy="535" r="45" fill="rgba(96,165,250,0.04)" />

    {/* central radial glow behind the network */}
    <circle cx="190" cy="300" r="175" fill="url(#netglow)" />

    {/* orbit ring */}
    <circle cx="190" cy="300" r="148" fill="none" stroke="rgba(96,165,250,0.08)" strokeWidth="1" strokeDasharray="5 8" />

    {/* ── CONNECTIONS L1 → L2  (blue) ── */}
    {/* layers: x = 55, 145, 235, 325  |  nodes: y = 230, 300, 370 */}
    <line x1="55" y1="230" x2="145" y2="230" stroke="rgba(96,165,250,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2s" repeatCount="indefinite" /></line>
    <line x1="55" y1="230" x2="145" y2="300" stroke="rgba(96,165,250,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.4s" repeatCount="indefinite" /></line>
    <line x1="55" y1="230" x2="145" y2="370" stroke="rgba(96,165,250,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.8s" repeatCount="indefinite" /></line>
    <line x1="55" y1="300" x2="145" y2="230" stroke="rgba(96,165,250,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.6s" repeatCount="indefinite" /></line>
    <line x1="55" y1="300" x2="145" y2="300" stroke="rgba(96,165,250,0.28)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.1s" repeatCount="indefinite" /></line>
    <line x1="55" y1="300" x2="145" y2="370" stroke="rgba(96,165,250,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.3s" repeatCount="indefinite" /></line>
    <line x1="55" y1="370" x2="145" y2="230" stroke="rgba(96,165,250,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.9s" repeatCount="indefinite" /></line>
    <line x1="55" y1="370" x2="145" y2="300" stroke="rgba(96,165,250,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.7s" repeatCount="indefinite" /></line>
    <line x1="55" y1="370" x2="145" y2="370" stroke="rgba(96,165,250,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.2s" repeatCount="indefinite" /></line>

    {/* ── CONNECTIONS L2 → L3  (purple) ── */}
    <line x1="145" y1="230" x2="235" y2="230" stroke="rgba(139,92,246,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.1s" repeatCount="indefinite" /></line>
    <line x1="145" y1="230" x2="235" y2="300" stroke="rgba(139,92,246,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.5s" repeatCount="indefinite" /></line>
    <line x1="145" y1="230" x2="235" y2="370" stroke="rgba(139,92,246,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.7s" repeatCount="indefinite" /></line>
    <line x1="145" y1="300" x2="235" y2="230" stroke="rgba(139,92,246,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.8s" repeatCount="indefinite" /></line>
    <line x1="145" y1="300" x2="235" y2="300" stroke="rgba(139,92,246,0.3)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2s" repeatCount="indefinite" /></line>
    <line x1="145" y1="300" x2="235" y2="370" stroke="rgba(139,92,246,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.3s" repeatCount="indefinite" /></line>
    <line x1="145" y1="370" x2="235" y2="230" stroke="rgba(139,92,246,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.9s" repeatCount="indefinite" /></line>
    <line x1="145" y1="370" x2="235" y2="300" stroke="rgba(139,92,246,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.6s" repeatCount="indefinite" /></line>
    <line x1="145" y1="370" x2="235" y2="370" stroke="rgba(139,92,246,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.2s" repeatCount="indefinite" /></line>

    {/* ── CONNECTIONS L3 → L4  (green) ── */}
    <line x1="235" y1="230" x2="325" y2="230" stroke="rgba(52,211,153,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2s" repeatCount="indefinite" /></line>
    <line x1="235" y1="230" x2="325" y2="300" stroke="rgba(52,211,153,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.4s" repeatCount="indefinite" /></line>
    <line x1="235" y1="230" x2="325" y2="370" stroke="rgba(52,211,153,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.8s" repeatCount="indefinite" /></line>
    <line x1="235" y1="300" x2="325" y2="230" stroke="rgba(52,211,153,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.7s" repeatCount="indefinite" /></line>
    <line x1="235" y1="300" x2="325" y2="300" stroke="rgba(52,211,153,0.3)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.1s" repeatCount="indefinite" /></line>
    <line x1="235" y1="300" x2="325" y2="370" stroke="rgba(52,211,153,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.5s" repeatCount="indefinite" /></line>
    <line x1="235" y1="370" x2="325" y2="230" stroke="rgba(52,211,153,0.08)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.9s" repeatCount="indefinite" /></line>
    <line x1="235" y1="370" x2="325" y2="300" stroke="rgba(52,211,153,0.14)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.3s" repeatCount="indefinite" /></line>
    <line x1="235" y1="370" x2="325" y2="370" stroke="rgba(52,211,153,0.22)" strokeWidth="0.8" strokeDasharray="4 3"><animate attributeName="stroke-dashoffset" from="0" to="-14" dur="2.8s" repeatCount="indefinite" /></line>

    {/* ── NODES L1  INPUT — blue ── */}
    <circle cx="55" cy="230" r="6" fill="#1a2f5e" stroke="#60a5fa" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5.5;7;5.5" dur="3s" repeatCount="indefinite" /></circle>
    <circle cx="55" cy="300" r="7" fill="#1a2f5e" stroke="#60a5fa" strokeWidth="2" filter="url(#glow)"><animate attributeName="r" values="6;8;6" dur="2.4s" repeatCount="indefinite" /></circle>
    <circle cx="55" cy="370" r="6" fill="#1a2f5e" stroke="#60a5fa" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5;6.5;5" dur="2.8s" repeatCount="indefinite" /></circle>

    {/* ── NODES L2  HIDDEN — purple ── */}
    <circle cx="145" cy="230" r="6" fill="#1a2f5e" stroke="#a78bfa" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5;6.5;5" dur="2.2s" repeatCount="indefinite" /></circle>
    <circle cx="145" cy="300" r="7" fill="#1a2f5e" stroke="#a78bfa" strokeWidth="2" filter="url(#glow)"><animate attributeName="r" values="6.5;8.5;6.5" dur="2s" repeatCount="indefinite" /></circle>
    <circle cx="145" cy="370" r="6" fill="#1a2f5e" stroke="#a78bfa" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5.5;7;5.5" dur="2.6s" repeatCount="indefinite" /></circle>

    {/* ── NODES L3  HIDDEN — violet ── */}
    <circle cx="235" cy="230" r="6" fill="#1a2f5e" stroke="#c4b5fd" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5.5;7;5.5" dur="1.9s" repeatCount="indefinite" /></circle>
    <circle cx="235" cy="300" r="7" fill="#1a2f5e" stroke="#c4b5fd" strokeWidth="2" filter="url(#glow)"><animate attributeName="r" values="6;8;6" dur="2.3s" repeatCount="indefinite" /></circle>
    <circle cx="235" cy="370" r="6" fill="#1a2f5e" stroke="#c4b5fd" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5;6.5;5" dur="2.7s" repeatCount="indefinite" /></circle>

    {/* ── NODES L4  OUTPUT — green, slightly larger ── */}
    <circle cx="325" cy="230" r="6" fill="#1a2f5e" stroke="#34d399" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5;6.5;5" dur="2.1s" repeatCount="indefinite" /></circle>
    <circle cx="325" cy="300" r="8" fill="#1a2f5e" stroke="#34d399" strokeWidth="2.5" filter="url(#glow)"><animate attributeName="r" values="7;9.5;7" dur="2s" repeatCount="indefinite" /></circle>
    <circle cx="325" cy="370" r="6" fill="#1a2f5e" stroke="#34d399" strokeWidth="1.6" filter="url(#glow)"><animate attributeName="r" values="5.5;7;5.5" dur="2.5s" repeatCount="indefinite" /></circle>

    {/* ── LAYER LABELS ── */}
    <text x="55" y="212" fontFamily="Inter,sans-serif" fontSize="8" fill="rgba(96,165,250,0.75)" textAnchor="middle" fontWeight="600" letterSpacing="1">INPUT</text>
    <text x="145" y="212" fontFamily="Inter,sans-serif" fontSize="8" fill="rgba(167,139,250,0.75)" textAnchor="middle" fontWeight="600" letterSpacing="1">HIDDEN</text>
    <text x="235" y="212" fontFamily="Inter,sans-serif" fontSize="8" fill="rgba(196,181,253,0.75)" textAnchor="middle" fontWeight="600" letterSpacing="1">HIDDEN</text>
    <text x="325" y="212" fontFamily="Inter,sans-serif" fontSize="8" fill="rgba(52,211,153,0.75)" textAnchor="middle" fontWeight="600" letterSpacing="1">OUTPUT</text>

    {/* ── DOMAIN CHIPS — four corners ── */}
    <g filter="url(#chipglow)" opacity="0.85">
      <rect x="16" y="108" width="56" height="19" rx="9.5" fill="rgba(96,165,250,0.13)" stroke="rgba(96,165,250,0.38)" strokeWidth="0.6" />
      <text x="44" y="121" textAnchor="middle" fontFamily="Inter,sans-serif" fontSize="7.5" fill="#93c5fd" fontWeight="600" letterSpacing="0.5">SAFETY</text>
    </g>
    <g filter="url(#chipglow)" opacity="0.85">
      <rect x="288" y="96" width="76" height="19" rx="9.5" fill="rgba(52,211,153,0.1)" stroke="rgba(52,211,153,0.38)" strokeWidth="0.6" />
      <text x="326" y="109" textAnchor="middle" fontFamily="Inter,sans-serif" fontSize="7.5" fill="#6ee7b7" fontWeight="600" letterSpacing="0.5">ALIGNMENT</text>
    </g>
    <g filter="url(#chipglow)" opacity="0.8">
      <rect x="288" y="478" width="74" height="19" rx="9.5" fill="rgba(251,191,36,0.1)" stroke="rgba(251,191,36,0.32)" strokeWidth="0.6" />
      <text x="325" y="491" textAnchor="middle" fontFamily="Inter,sans-serif" fontSize="7.5" fill="#fcd34d" fontWeight="600" letterSpacing="0.5">RED TEAM</text>
    </g>
    <g filter="url(#chipglow)" opacity="0.8">
      <rect x="12" y="466" width="82" height="19" rx="9.5" fill="rgba(167,139,250,0.1)" stroke="rgba(167,139,250,0.32)" strokeWidth="0.6" />
      <text x="53" y="479" textAnchor="middle" fontFamily="Inter,sans-serif" fontSize="7.5" fill="#c4b5fd" fontWeight="600" letterSpacing="0.5">GOVERNANCE</text>
    </g>
  </svg>
);

const ShieldIcon = ({ color = "#60a5fa", size = 28, fillOpacity = 0.12 }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
    <path
      d="M14 2L24 7.5V20.5L14 26L4 20.5V7.5L14 2Z"
      stroke={color}
      strokeWidth="1.6"
      fill={`rgba(${color === "#60a5fa" ? "96,165,250" : "45,107,196"},${fillOpacity})`}
    />
    <path d="M10 14h8M14 10v8" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const UserIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="7" cy="5" r="2.5" stroke="#b0bfcc" strokeWidth="1.2" />
    <path d="M2 12c0-2.5 2.2-4 5-4s5 1.5 5 4" stroke="#b0bfcc" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const LockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <rect x="2.5" y="6" width="9" height="6" rx="1.5" stroke="#b0bfcc" strokeWidth="1.2" />
    <path d="M4.5 6V4.5a2.5 2.5 0 015 0V6" stroke="#b0bfcc" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const KeyIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <rect x="1" y="4" width="12" height="7" rx="1.5" stroke="#b0bfcc" strokeWidth="1.2" />
    <path d="M4 4V3a3 3 0 016 0v1" stroke="#b0bfcc" strokeWidth="1.2" />
  </svg>
);

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [errors, setErrors] = useState({});
  const [focusedField, setFocusedField] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const generateCaptcha = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!username) newErrors.username = "Please input email";
    if (!password) newErrors.password = "Please input password";
    if (!verificationCode) {
      newErrors.verificationCode = "Please input Verification Code";
    } else if (verificationCode.toUpperCase() !== captcha) {
      newErrors.verificationCode = "Verification code does not match";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) return;

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: username, password }),
      });
      if (!response.ok) throw new Error("Login failed");
      const data = await response.json();
      login({ fullName: data.full_name, token: data.access_token });
      navigate("/", { replace: true });
    } catch {
      setErrors({ loginfail: "Login failed. Please check your credentials." });
    }
  };

  const inputStyle = (field) => ({
    width: "100%",
    background: focusedField === field ? "#fff" : "#f7f9fc",
    border: `1px solid ${focusedField === field ? "#2d6bc4" : "#dde6f0"}`,
    borderRadius: "6px",
    padding: "10px 14px 10px 38px",
    fontSize: "13px",
    fontFamily: "Inter, sans-serif",
    color: "#0d1e3a",
    outline: "none",
    boxShadow: focusedField === field ? "0 0 0 3px rgba(45,107,196,0.08)" : "none",
    transition: "border-color 0.2s, background 0.2s, box-shadow 0.2s",
  });

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', sans-serif; }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        .login-btn:hover { background: #1d54d4 !important; }
        .login-btn:hover .btn-arrow { transform: translateX(3px); }
        .btn-arrow { transition: transform 0.2s; }
        ::placeholder { color: #c0ccd8; }
      `}</style>

      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          fontFamily: "Inter, sans-serif",
          background: "#eef2f7",
        }}
      >
        {/* Left panel */}
        <div
          style={{
            flex: "1.2",
            padding: "44px 40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
            overflow: "hidden",
            background: "#1a2f5e",
          }}
        >
          <HexPattern2 />

          {/* Logo */}
          <div style={{ position: "relative", zIndex: 2, display: "flex", alignItems: "center", gap: "10px" }}>
            <ShieldIcon color="#60a5fa" size={34} fillOpacity={0.15} />
            <div>
              <div style={{ fontSize: "16px", fontWeight: 700, color: "#fff", letterSpacing: "0.4px" }}>AI Guardian</div>
              <div style={{ fontSize: "9px", color: "rgba(96,165,250,0.65)", letterSpacing: "2.5px", textTransform: "uppercase", marginTop: "2px" }}>Platform</div>
            </div>
          </div>

          {/* Status */}
          <div style={{ position: "relative", zIndex: 2 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {[
                { dot: "#34d399", label: "Safety Evaluation", status: "" },
                { dot: "#60a5fa", label: "Red Team Engine",   status: ""  },
                { dot: "#a78bfa", label: "Alignment Monitor", status: "" },
              ].map(({ dot, label, status }) => (
                <div key={label} style={{ display: "flex", alignItems: "center", gap: "9px" }}>
                  <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: dot, boxShadow: `0 0 7px ${dot}`, flexShrink: 0 }} />
                  <span style={{ fontSize: "11px", color: "rgba(176,200,220,0.65)", flex: 1 }}>{label}</span>
                  <span style={{ fontSize: "10px", color: dot, fontWeight: 600 }}>{status}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: "14px", paddingTop: "12px", borderTop: "1px solid rgba(255,255,255,0.07)", fontSize: "10px", color: "rgba(255,255,255,0.2)", letterSpacing: "0.5px" }}>
              AI Guardian Platform · v2.0
            </div>
          </div>
        </div>

        {/* Right panel */}
        <div
          style={{
            flex: 1,
            background: "#fff",
            padding: "48px 44px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            borderLeft: "0.5px solid #dde6f0",
          }}
        >
          {/* Brand */}
          {/* <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "28px" }}>
            <ShieldIcon color="#2d6bc4" size={22} fillOpacity={0.08} />
            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a2a4a", letterSpacing: "0.5px" }}>
              AI Guardian
            </span>
          </div> */}
          <div className="flex justify-center mb-8">
            <img src={logo} alt="AI Guardian Logo" />
          </div>
          <h2 style={{ fontSize: "20px", fontWeight: 600, color: "#0d1e3a", marginBottom: "6px" }}>
            Please log in
          </h2>
          <p style={{ fontSize: "12px", color: "#9aafc4", lineHeight: 1.6, marginBottom: "28px" }}>
            Design adversarial testing scenarios to evaluate AI model security, robustness, and ethical compliance.
          </p>

          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#3d5a7a", marginBottom: "7px" }}>
                <span style={{ color: "#e24b4a", marginRight: "2px" }}>*</span>Username/Email
              </label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", display: "flex" }}>
                  <UserIcon />
                </span>
                <input
                  type="text"
                  placeholder="Please enter username/email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onFocus={() => setFocusedField("username")}
                  onBlur={() => setFocusedField(null)}
                  style={inputStyle("username")}
                />
              </div>
              {errors.username && <p style={{ color: "#e24b4a", fontSize: "11px", marginTop: "5px" }}>{errors.username}</p>}
            </div>

            {/* Password */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#3d5a7a", marginBottom: "7px" }}>
                <span style={{ color: "#e24b4a", marginRight: "2px" }}>*</span>Password
              </label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", display: "flex" }}>
                  <LockIcon />
                </span>
                <input
                  type="password"
                  placeholder="Please enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocusedField("password")}
                  onBlur={() => setFocusedField(null)}
                  style={inputStyle("password")}
                />
              </div>
              {errors.password && <p style={{ color: "#e24b4a", fontSize: "11px", marginTop: "5px" }}>{errors.password}</p>}
            </div>

            {/* Verification Code */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#3d5a7a", marginBottom: "7px" }}>
                Verification Code
              </label>
              <div style={{ display: "flex", gap: "8px", alignItems: "stretch" }}>
                <div style={{ position: "relative", flex: 1 }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", display: "flex" }}>
                    <KeyIcon />
                  </span>
                  <input
                    type="text"
                    placeholder="Please enter Verification Code"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    onFocus={() => setFocusedField("verificationCode")}
                    onBlur={() => setFocusedField(null)}
                    style={inputStyle("verificationCode")}
                  />
                </div>
                <div
                  onClick={generateCaptcha}
                  title="Click to refresh"
                  style={{
                    background: "#edf3fb",
                    border: "1px solid #c5d8f5",
                    borderRadius: "6px",
                    padding: "0 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    minWidth: "68px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "monospace",
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#2d6bc4",
                      letterSpacing: "4px",
                      userSelect: "none",
                      textDecoration: "line-through",
                      textDecorationColor: "rgba(45,107,196,0.3)",
                    }}
                  >
                    {captcha}
                  </span>
                </div>
              </div>
              {errors.verificationCode && <p style={{ color: "#e24b4a", fontSize: "11px", marginTop: "5px" }}>{errors.verificationCode}</p>}
              {errors.loginfail && <p style={{ color: "#e24b4a", fontSize: "11px", marginTop: "5px" }}>{errors.loginfail}</p>}
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="login-btn"
              style={{
                width: "100%",
                background: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "11px",
                fontFamily: "Inter, sans-serif",
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                marginTop: "20px",
                transition: "background 0.2s",
              }}
            >
              Log in
              <span className="btn-arrow">→</span>
            </button>
          </form>
        </div>
      </div>
    </>
  );
}